import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow , TableSortLabel} from '@mui/material';
import React from 'react';

import AssetStateUpdate from './AssetStateUpdateDialog';
import LoadingTableRow from './LoadingTableRow';
import AssetIssueForm from './AssetIssueFormDialog';
import ParameterOverrideForm from './ParameterOverrideDialog';
import AssetCheckDialog from './AssetCheckDialog';

const AssetOverviewTable = ({
  restrictStatusChangeToGroundedOnly,
  isLoading,
  assets,
  parameters,
  cells,
  onRequestStatusChange,
  onRequestNewIssue,
  onRequestNewOverride,
  onRequestSort,
  onRequestDeleteOverride,
}) => {
  const [sortBy, setSortBy] = React.useState('lastCheck');
  const [order, setOrder] = React.useState<'desc' | 'asc'>('desc');
  const createSortHandler =
    (property: string) => (event: React.MouseEvent<unknown>) => {
      if (property === sortBy) {
        setOrder(order === 'asc' ? 'desc' : 'asc');
      } else {
        setOrder('desc')
      }
      setSortBy(property)
      onRequestSort(event, property, order);
    };

  return (<TableContainer component={Paper}>
    <Table sx={{ minWidth: 650 }} aria-label="assets table">
      <TableHead>
        <TableRow>
          <TableCell>
            <TableSortLabel
              active={sortBy === 'assetName'}
              direction={order}
              onClick={createSortHandler('assetName')}
            >
              Craft
            </TableSortLabel>
          </TableCell>
          <TableCell>
            <TableSortLabel
              active={sortBy === 'state'}
              direction={order}
              onClick={createSortHandler('state')}
            >
              State
            </TableSortLabel>
          </TableCell>
          <TableCell>
            <TableSortLabel
              active={sortBy === 'lastCheck'}
              direction={order}
              onClick={createSortHandler('lastCheck')}
            >
              Last checked
            </TableSortLabel>
          </TableCell>
          <TableCell>
            <TableSortLabel
              active={sortBy === 'versionName'}
              direction={order}
              onClick={createSortHandler('versionName')}
            >
              Version
            </TableSortLabel>
          </TableCell>
          <TableCell></TableCell>
          <TableCell></TableCell>
          <TableCell></TableCell>
          {restrictStatusChangeToGroundedOnly ? <></> : <TableCell></TableCell>}
        </TableRow>
      </TableHead>
      <TableBody>
        {isLoading ? <LoadingTableRow /> : <></>}
        {!isLoading && assets.map((asset) => (
          <TableRow
            key={asset.id}
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
          >
            <TableCell component="th" scope="row">
              {asset.assetName}
            </TableCell>
            <TableCell>
              <p>{asset.state}</p>
              <p>{asset.stateReason}</p>
            </TableCell>
            <TableCell>
              <p>{new Date(asset.lastCheck).toLocaleString(['en-IE', 'en-GB'])}</p>
              <p>{asset.lastCheckBy}</p>
            </TableCell>
            <TableCell>{asset.versionName}</TableCell>
            <TableCell>
              <AssetCheckDialog assetId={asset.id}/>
            </TableCell>
            <TableCell>
              <AssetStateUpdate assetId={asset.id} state={asset.state} restrictStatusChangeToGroundedOnly={restrictStatusChangeToGroundedOnly} onClickStatusUpdateForCraft={(id, state, reason) => onRequestStatusChange(id, state, reason)} />
            </TableCell>
            {restrictStatusChangeToGroundedOnly ? <></> :<TableCell>
              <AssetIssueForm assetId={asset.id} state={asset.state} onClickCreateIssue={(id, data) => onRequestNewIssue(id, data)} />
            </TableCell>}
            <TableCell>
              <ParameterOverrideForm assetId={asset.id} parameters={parameters} cells={cells} onClickCreateOverride={(id, data) => onRequestNewOverride(id, data)} onClickDeleteOverride={(id) => onRequestDeleteOverride(id)} />
            </TableCell>
        </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>);
};

export default AssetOverviewTable;
